import ApiService from './api.service';

const AdminService = {
    login: async (credentials) => {
        return ApiService.fetch('admin/login', {
            method: 'POST',
            body: JSON.stringify(credentials)
        });
    },

    logout: async () => {
        try {
            const response = await ApiService.fetch('admin/logout', {
                method: 'POST'
            });

            localStorage.removeItem('auth_token');
            localStorage.removeItem('user');
            return response;
        } catch (error) {
            localStorage.removeItem('auth_token');
            localStorage.removeItem('user');
            throw error;
        }
    },

    getProfile: async () => {
        return ApiService.fetch('admin/profile');
    },

    // Gestione dottori
    createDoctor: (doctorData) => {
        return ApiService.fetch('admin/doctors', {
            method: 'POST',
            body: JSON.stringify(doctorData)
        });
    },

    updateDoctor: (doctorId, doctorData) => {
        return ApiService.fetch(`admin/doctors/${doctorId}`, {
            method: 'PUT',
            body: JSON.stringify(doctorData)
        });
    },

    getDoctors: () => {
        return ApiService.fetch('admin/doctors');
    },

    getDoctor: (doctorId) => {
        return ApiService.fetch(`admin/doctors/${doctorId}`);
    },

    // Gestione servizi professionista
    getDoctorServices: (doctorId) => {
        return ApiService.fetch(`admin/doctors/${doctorId}/services`);
    },

    createDoctorService: (doctorId, serviceData) => {
        return ApiService.fetch(`admin/doctors/${doctorId}/services`, {
            method: 'POST',
            body: JSON.stringify(serviceData)
        });
    },

    updateDoctorService: (doctorId, serviceId, serviceData) => {
        return ApiService.fetch(`admin/doctors/${doctorId}/services/${serviceId}`, {
            method: 'PUT',
            body: JSON.stringify(serviceData)
        });
    },

    deleteDoctorService: (doctorId, serviceId) => {
        return ApiService.fetch(`admin/doctors/${doctorId}/services/${serviceId}`, {
            method: 'DELETE'
        });
    },

    getActivityLogs: () => {
        return ApiService.fetch('activity-logs');
    },

    getInactiveTherapists: () => {
        return ApiService.fetch('admin/therapists/inactive');
    },
    
};

export default AdminService;